module.exports = __webpack_public_path__ + "img/ic-dashboard-unselect.9a8f1a7e.svg";